/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NXT48
 * API documentation generated from Zod schemas
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SystemDetailedHealthcheck200,
  SystemDetailedHealthcheck400,
  SystemGetGeminiModels200,
  SystemGetGeminiModels400,
  SystemGetPublicConfig200,
  SystemGetPublicConfig400,
  SystemGetSystemConfigs200Item,
  SystemGetSystemConfigs400,
  SystemGetSystemConfigsParams,
  SystemHealthcheck200,
  SystemHealthcheck400,
  SystemMetrics400,
  SystemReadiness200,
  SystemReadiness400,
  SystemUpdateSystemConfigs200,
  SystemUpdateSystemConfigs400,
  SystemUpdateSystemConfigsBody
} from '../nxt48.schemas';

import { customInstance } from '../../orval-fetcher';




/**
 * Get public system configurations (no authentication required)
 * @summary Get Public Config
 */
export const systemGetPublicConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemGetPublicConfig200>(
      {url: `/system/config/public`, method: 'GET', signal
    },
      );
    }
  



export const getSystemGetPublicConfigQueryKey = () => {
    return [
    `/system/config/public`
    ] as const;
    }

    
export const getSystemGetPublicConfigQueryOptions = <TData = Awaited<ReturnType<typeof systemGetPublicConfig>>, TError = SystemGetPublicConfig400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemGetPublicConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemGetPublicConfig>>> = ({ signal }) => systemGetPublicConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemGetPublicConfigQueryResult = NonNullable<Awaited<ReturnType<typeof systemGetPublicConfig>>>
export type SystemGetPublicConfigQueryError = SystemGetPublicConfig400


export function useSystemGetPublicConfig<TData = Awaited<ReturnType<typeof systemGetPublicConfig>>, TError = SystemGetPublicConfig400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetPublicConfig>>,
          TError,
          Awaited<ReturnType<typeof systemGetPublicConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetPublicConfig<TData = Awaited<ReturnType<typeof systemGetPublicConfig>>, TError = SystemGetPublicConfig400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetPublicConfig>>,
          TError,
          Awaited<ReturnType<typeof systemGetPublicConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetPublicConfig<TData = Awaited<ReturnType<typeof systemGetPublicConfig>>, TError = SystemGetPublicConfig400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Public Config
 */

export function useSystemGetPublicConfig<TData = Awaited<ReturnType<typeof systemGetPublicConfig>>, TError = SystemGetPublicConfig400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetPublicConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemGetPublicConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all system configurations (admin only)
 * @summary Get System Configs
 */
export const systemGetSystemConfigs = (
    params?: SystemGetSystemConfigsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemGetSystemConfigs200Item[]>(
      {url: `/system/admin/configs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSystemGetSystemConfigsQueryKey = (params?: SystemGetSystemConfigsParams,) => {
    return [
    `/system/admin/configs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSystemGetSystemConfigsQueryOptions = <TData = Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError = SystemGetSystemConfigs400 | void>(params?: SystemGetSystemConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemGetSystemConfigsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemGetSystemConfigs>>> = ({ signal }) => systemGetSystemConfigs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemGetSystemConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof systemGetSystemConfigs>>>
export type SystemGetSystemConfigsQueryError = SystemGetSystemConfigs400 | void


export function useSystemGetSystemConfigs<TData = Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError = SystemGetSystemConfigs400 | void>(
 params: undefined |  SystemGetSystemConfigsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetSystemConfigs>>,
          TError,
          Awaited<ReturnType<typeof systemGetSystemConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetSystemConfigs<TData = Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError = SystemGetSystemConfigs400 | void>(
 params?: SystemGetSystemConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetSystemConfigs>>,
          TError,
          Awaited<ReturnType<typeof systemGetSystemConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetSystemConfigs<TData = Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError = SystemGetSystemConfigs400 | void>(
 params?: SystemGetSystemConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get System Configs
 */

export function useSystemGetSystemConfigs<TData = Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError = SystemGetSystemConfigs400 | void>(
 params?: SystemGetSystemConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetSystemConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemGetSystemConfigsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update system configurations (admin only)
 * @summary Update System Configs
 */
export const systemUpdateSystemConfigs = (
    systemUpdateSystemConfigsBody: SystemUpdateSystemConfigsBody,
 ) => {
      
      
      return customInstance<SystemUpdateSystemConfigs200>(
      {url: `/system/admin/configs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: systemUpdateSystemConfigsBody
    },
      );
    }
  


export const getSystemUpdateSystemConfigsMutationOptions = <TError = SystemUpdateSystemConfigs400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof systemUpdateSystemConfigs>>, TError,{data: SystemUpdateSystemConfigsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof systemUpdateSystemConfigs>>, TError,{data: SystemUpdateSystemConfigsBody}, TContext> => {

const mutationKey = ['systemUpdateSystemConfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof systemUpdateSystemConfigs>>, {data: SystemUpdateSystemConfigsBody}> = (props) => {
          const {data} = props ?? {};

          return  systemUpdateSystemConfigs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SystemUpdateSystemConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof systemUpdateSystemConfigs>>>
    export type SystemUpdateSystemConfigsMutationBody = SystemUpdateSystemConfigsBody
    export type SystemUpdateSystemConfigsMutationError = SystemUpdateSystemConfigs400 | void

    /**
 * @summary Update System Configs
 */
export const useSystemUpdateSystemConfigs = <TError = SystemUpdateSystemConfigs400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof systemUpdateSystemConfigs>>, TError,{data: SystemUpdateSystemConfigsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof systemUpdateSystemConfigs>>,
        TError,
        {data: SystemUpdateSystemConfigsBody},
        TContext
      > => {

      const mutationOptions = getSystemUpdateSystemConfigsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get available Gemini models from API (admin only)
 * @summary Get Gemini Models
 */
export const systemGetGeminiModels = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemGetGeminiModels200>(
      {url: `/system/admin/gemini-models`, method: 'GET', signal
    },
      );
    }
  



export const getSystemGetGeminiModelsQueryKey = () => {
    return [
    `/system/admin/gemini-models`
    ] as const;
    }

    
export const getSystemGetGeminiModelsQueryOptions = <TData = Awaited<ReturnType<typeof systemGetGeminiModels>>, TError = SystemGetGeminiModels400 | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemGetGeminiModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemGetGeminiModels>>> = ({ signal }) => systemGetGeminiModels(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemGetGeminiModelsQueryResult = NonNullable<Awaited<ReturnType<typeof systemGetGeminiModels>>>
export type SystemGetGeminiModelsQueryError = SystemGetGeminiModels400 | void


export function useSystemGetGeminiModels<TData = Awaited<ReturnType<typeof systemGetGeminiModels>>, TError = SystemGetGeminiModels400 | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetGeminiModels>>,
          TError,
          Awaited<ReturnType<typeof systemGetGeminiModels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetGeminiModels<TData = Awaited<ReturnType<typeof systemGetGeminiModels>>, TError = SystemGetGeminiModels400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetGeminiModels>>,
          TError,
          Awaited<ReturnType<typeof systemGetGeminiModels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemGetGeminiModels<TData = Awaited<ReturnType<typeof systemGetGeminiModels>>, TError = SystemGetGeminiModels400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Gemini Models
 */

export function useSystemGetGeminiModels<TData = Awaited<ReturnType<typeof systemGetGeminiModels>>, TError = SystemGetGeminiModels400 | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetGeminiModels>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemGetGeminiModelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Basic healthcheck endpoint
 * @summary Healthcheck
 */
export const systemHealthcheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemHealthcheck200>(
      {url: `/system/health`, method: 'GET', signal
    },
      );
    }
  



export const getSystemHealthcheckQueryKey = () => {
    return [
    `/system/health`
    ] as const;
    }

    
export const getSystemHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof systemHealthcheck>>, TError = SystemHealthcheck400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemHealthcheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemHealthcheck>>> = ({ signal }) => systemHealthcheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemHealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof systemHealthcheck>>>
export type SystemHealthcheckQueryError = SystemHealthcheck400


export function useSystemHealthcheck<TData = Awaited<ReturnType<typeof systemHealthcheck>>, TError = SystemHealthcheck400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof systemHealthcheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemHealthcheck<TData = Awaited<ReturnType<typeof systemHealthcheck>>, TError = SystemHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof systemHealthcheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemHealthcheck<TData = Awaited<ReturnType<typeof systemHealthcheck>>, TError = SystemHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Healthcheck
 */

export function useSystemHealthcheck<TData = Awaited<ReturnType<typeof systemHealthcheck>>, TError = SystemHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemHealthcheck>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemHealthcheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Detailed healthcheck with system component status
 * @summary Detailed Healthcheck
 */
export const systemDetailedHealthcheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemDetailedHealthcheck200>(
      {url: `/system/health/detailed`, method: 'GET', signal
    },
      );
    }
  



export const getSystemDetailedHealthcheckQueryKey = () => {
    return [
    `/system/health/detailed`
    ] as const;
    }

    
export const getSystemDetailedHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError = SystemDetailedHealthcheck400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemDetailedHealthcheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemDetailedHealthcheck>>> = ({ signal }) => systemDetailedHealthcheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemDetailedHealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof systemDetailedHealthcheck>>>
export type SystemDetailedHealthcheckQueryError = SystemDetailedHealthcheck400


export function useSystemDetailedHealthcheck<TData = Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError = SystemDetailedHealthcheck400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemDetailedHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof systemDetailedHealthcheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemDetailedHealthcheck<TData = Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError = SystemDetailedHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemDetailedHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof systemDetailedHealthcheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemDetailedHealthcheck<TData = Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError = SystemDetailedHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Detailed Healthcheck
 */

export function useSystemDetailedHealthcheck<TData = Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError = SystemDetailedHealthcheck400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemDetailedHealthcheck>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemDetailedHealthcheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Readiness check for Kubernetes
 * @summary Readiness
 */
export const systemReadiness = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SystemReadiness200>(
      {url: `/system/ready`, method: 'GET', signal
    },
      );
    }
  



export const getSystemReadinessQueryKey = () => {
    return [
    `/system/ready`
    ] as const;
    }

    
export const getSystemReadinessQueryOptions = <TData = Awaited<ReturnType<typeof systemReadiness>>, TError = SystemReadiness400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemReadinessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemReadiness>>> = ({ signal }) => systemReadiness(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof systemReadiness>>>
export type SystemReadinessQueryError = SystemReadiness400


export function useSystemReadiness<TData = Awaited<ReturnType<typeof systemReadiness>>, TError = SystemReadiness400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemReadiness>>,
          TError,
          Awaited<ReturnType<typeof systemReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemReadiness<TData = Awaited<ReturnType<typeof systemReadiness>>, TError = SystemReadiness400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemReadiness>>,
          TError,
          Awaited<ReturnType<typeof systemReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemReadiness<TData = Awaited<ReturnType<typeof systemReadiness>>, TError = SystemReadiness400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Readiness
 */

export function useSystemReadiness<TData = Awaited<ReturnType<typeof systemReadiness>>, TError = SystemReadiness400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemReadinessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get application metrics
 * @summary Metrics
 */
export const systemMetrics = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/system/metrics`, method: 'GET', signal
    },
      );
    }
  



export const getSystemMetricsQueryKey = () => {
    return [
    `/system/metrics`
    ] as const;
    }

    
export const getSystemMetricsQueryOptions = <TData = Awaited<ReturnType<typeof systemMetrics>>, TError = SystemMetrics400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemMetricsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemMetrics>>> = ({ signal }) => systemMetrics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SystemMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof systemMetrics>>>
export type SystemMetricsQueryError = SystemMetrics400


export function useSystemMetrics<TData = Awaited<ReturnType<typeof systemMetrics>>, TError = SystemMetrics400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemMetrics>>,
          TError,
          Awaited<ReturnType<typeof systemMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemMetrics<TData = Awaited<ReturnType<typeof systemMetrics>>, TError = SystemMetrics400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemMetrics>>,
          TError,
          Awaited<ReturnType<typeof systemMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSystemMetrics<TData = Awaited<ReturnType<typeof systemMetrics>>, TError = SystemMetrics400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Metrics
 */

export function useSystemMetrics<TData = Awaited<ReturnType<typeof systemMetrics>>, TError = SystemMetrics400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSystemMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




